import React, { useState, useEffect } from "react";
import "./Parent.scss";
import ParentHeader from "./parentHeader/ParentHeader";
import Footer from "./footer/Footer";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { isEmpty } from "../custom_utilities/custom_useful_functions";
import images from "../utilities/images/images";

//// redux ////
import uiActions from "../redux/ui/action";
import { connect } from "react-redux";
import {
  setUserId,
  setStudentProfileDetails,
  setParentTarget,
} from "../parent/redux/authSlice/AuthSlice";

import LoaderPopUp from "../components/loader/loader";
import {
  setPaperId,
  setPlannerTestId,
  setPapers,
} from "./redux/testDataSlice/TestDataSlice";
import ParentContentComponent from "./parentContentComponent/ParentContentComponent";
const Parent = (props) => {
  let {
    finishLoading,
    startLoading,
    loader,
    studentRollNum,
    setUserId,
    setPaperId,
    setPlannerTestId,
    setPapers,
    setStudentProfileDetails,
    parentUserId,
    setParentTarget,
  } = props;
  let history = useHistory();

  let [state, setState] = useState({
    studentData: {},
  });

  let { studentData } = state;

  useEffect(() => {
    // Call the necessary functions when the component mounts
    getStudentData();
  }, []);

  const handleRedirect = () => {
    // Redirect to the student-tests page with necessary parameters
    history.push({
      pathname: "/student-tests",
      state: { step: 1, roll_no: studentRollNum },
    });
  };

  const handleRedirect2 = (element) => {
    // Set necessary parameters and redirect to the student-tests page
    setPaperId(element.paper_id);
    setPlannerTestId(element.planner_test_id);

    setPapers(element.papers);
    history.push({
      pathname: "/student-tests",
      state: { step: 2 },
    });
  };

  const handleRedirect3 = (paperId) => {
    // Set the paperId parameter and redirect to the student-report-pdf page
    setPaperId(paperId);
    history.push({
      pathname: "/student-report-pdf",
      state: { paper_id: paperId },
    });
  };

  const getStudentData = async () => {
    // Get the student data
    let data = {
      roll_no: studentRollNum,
      device: "Web",
    };

    try {
      const response = await axios.post(
        "https://learning.motion.ac.in/motioneducation/api/SPR_StudentOverallSummary",
        data
      );

      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          studentData: response.data.student_data,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.toLocaleString("en-US", { day: "2-digit" });
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.toLocaleString("en-US", { year: "numeric" });
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <div className="containers">
        <ParentHeader
          studentRollNum={studentRollNum}
          studentData={studentData}
        />
        <div className="container">
          <ParentContentComponent
            finishLoading={finishLoading}
            startLoading={startLoading}
            studentRollNum={studentRollNum}
            setUserId={setUserId}
            setStudentProfileDetails={setStudentProfileDetails}
            setParentTarget={setParentTarget}
            loader={loader}
            LoaderPopUp={LoaderPopUp}
            parentUserId={parentUserId}
          />

          <div className="topicwise-heading">
            <div className="section-heading">Test-wise Analysis</div>
            <button className="viewAllTestBt" onClick={handleRedirect}>
              View all Tests
            </button>
          </div>
          <div className="parentTopicWiseWrapper">
            {/* {!isEmpty(state.studentData)
              ? state.studentData.data.length
                ? state.studentData.data.map((element, index) => {
                    return (
                      <div key={index} className="topicWiseCard">
                        <div className="card-body">
                          <div className="card-title">
                            <div className="text">RBTS Full Test</div>
                            <div className="date">
                              {formatDate(
                                element.student_summary.to_be_held_on
                              )}
                            </div>
                          </div>

                          <div className="card-contain">
                            <div className="lft">
                              <div className="lft-top">
                                <ul>
                                  <li>
                                    <div className="TestReportCard">
                                      <div className="text">
                                        <div className="text-top">Marks</div>
                                        <div>
                                          <div className="text-btm ">
                                            Out of 300
                                          </div>
                                        </div>
                                      </div>
                                      <div className="num marks">
                                        {element.student_summary.total_marks}
                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div className="TestReportCard">
                                      <div className="text">
                                        <div className="text-top">Rank</div>
                                        <div>
                                          <div className="text-btm">
                                            600 Students
                                          </div>
                                        </div>
                                      </div>
                                      <div className="num rank">
                                        {element.student_summary.rank}
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="TestReportCard">
                                      <div className="text">
                                        <div className="text-top">Accuracy</div>
                                      </div>
                                      <div className="num">
                                        {element.student_summary.Accuracy}
                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div className="TestReportCard">
                                      <div className="text">
                                        <div className="text-top">
                                          Highest Marks
                                        </div>
                                      </div>
                                      <div className="num">
                                        {element.student_summary.highest_marks}
                                      </div>
                                    </div>
                                  </li>

                                  <li>
                                    <div className="TestReportCard">
                                      <div className="text">
                                        <div className="text-top">
                                          Average Marks
                                        </div>
                                      </div>
                                      <div className="num">
                                        {element.student_summary.avg_score}
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                              <div className="lft-btm">
                                <div
                                  className="percentageBox"
                                  style={{
                                    backgroundColor:
                                      element.student_summary.performance,
                                  }}
                                >
                                  <div>
                                    <div className="text">Percentile</div>
                                    <div className="num">
                                      {element.student_summary.percentile}
                                    </div>
                                  </div>
                                  <div className="img">
                                    <img
                                      src={images.user_activity_46}
                                      alt="img"
                                    />
                                  </div>

                                  <div>
                                    <div className="text">Percentage</div>
                                    <div className="num">
                                      {element.student_summary.percentage}
                                    </div>
                                  </div>
                                </div>

                                <div className="subjs">
                                  <ul>
                                    {element.student_summary?.Physics
                                      ?.user_score !== null &&
                                    element.student_summary?.Physics
                                      ?.user_score !== 0 ? (
                                      <li className="li-1">
                                        <div className="text">Physics</div>
                                        <div className="num">
                                          {
                                            element.student_summary?.Physics
                                              ?.rank
                                          }
                                        </div>
                                      </li>
                                    ) : null}

                                    {element.student_summary?.Chemistry
                                      ?.user_score !== null &&
                                    element.student_summary?.Chemistry
                                      ?.user_score !== 0 ? (
                                      <li className="li-2">
                                        <div className="text">Chemistry</div>
                                        <div className="num">
                                          {
                                            element.student_summary?.Chemistry
                                              ?.rank
                                          }
                                        </div>
                                      </li>
                                    ) : null}

                                    {element.student_summary?.Maths
                                      ?.user_score !== null &&
                                    element.student_summary?.Maths
                                      ?.user_score !== 0 ? (
                                      <li className="li-3">
                                        <div className="text">Maths</div>
                                        <div className="num">
                                          {element.student_summary?.Maths?.rank}
                                        </div>
                                      </li>
                                    ) : null}

                                    {element.student_summary?.Botany
                                      ?.user_score !== null &&
                                    element.student_summary?.Botany
                                      ?.user_score !== 0 ? (
                                      <li className="li-1">
                                        <div className="text">Botany</div>
                                        <div className="num">
                                          {
                                            element.student_summary?.Botany
                                              ?.rank
                                          }
                                        </div>
                                      </li>
                                    ) : null}

                                    {element.student_summary?.Zoology
                                      ?.user_score !== null &&
                                    element.student_summary?.Botany
                                      ?.user_score !== 0 ? (
                                      <li>
                                        <div className="text">Zoology</div>
                                        <div className="num">
                                          {
                                            element.student_summary?.Zoology
                                              ?.rank
                                          }
                                        </div>
                                      </li>
                                    ) : null}
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div className="rght">
                              <div className="viewReport">
                                <button
                                  onClick={() => handleRedirect2(element)}
                                >
                                  <span className="text">View report</span>
                                  <span>
                                    <div className="img">
                                      <img
                                        src={images.user_activity_47}
                                        alt="img"
                                      />
                                    </div>
                                  </span>
                                </button>
                              </div>
                              <div className="downloadReport">
                                <button
                                  onClick={() =>
                                    handleRedirect3(element.paper_id)
                                  }
                                >
                                  <span className="text">Download report</span>
                                  <span>
                                    <div className="img">
                                      <img
                                        src={images.user_activity_48}
                                        alt="img"
                                      />
                                    </div>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : null
              : null} */}

            <div className="parentTopicWiseInnerWrapper">
              {!isEmpty(state.studentData) ? (
                state.studentData.data.length ? (
                  state.studentData.data.map((element, index) => (
                    <RbtsFullTest
                      key={index}
                      studentData={element}
                      // handleStep2={handleStep2}
                      setPaperId={setPaperId}
                    />
                  ))
                ) : (
                  <div className="no-data">
                    <div className="img">
                      <img src={images.m2_video_ntF} alt="img" />
                      <div className="no-data-text">No Data Found!</div>
                    </div>
                  </div>
                )
              ) : null}
            </div>

            {loader && <LoaderPopUp />}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

// Redux state mapping to component props
const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    studentRollNum: state.parentrootReducer.parentAuthReducer.user.st_rollno,
    parentUserId: state.parentrootReducer.parentAuthReducer.userId,
  };
};

// Redux dispatch mapping to component props
const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUserId: (payload) => {
      dispatch(setUserId(payload));
    },

    setPaperId: (payload) => {
      dispatch(setPaperId(payload));
    },

    setPlannerTestId: (payload) => {
      dispatch(setPlannerTestId(payload));
    },

    setPapers: (payload) => {
      dispatch(setPapers(payload));
    },
    setStudentProfileDetails: (payload) => {
      dispatch(setStudentProfileDetails(payload));
    },

    setParentTarget: (payload) => {
      dispatch(setParentTarget(payload));
    },
  };
};

const RbtsFullTest = (props) => {
  // let { studentData, handleStep2, setPaperId } = props;
  let { studentData, setPaperId } = props;

  console.log("studentData", studentData);

  let history = useHistory();

  const handleRedirect = (paperId) => {
    setPaperId(paperId);
    history.push({
      pathname: "/student-report-pdf",
    });
  };

  const date = new Date(studentData.student_summary.to_be_held_on);
  const day = date.toLocaleString("en-US", { day: "2-digit" });
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.toLocaleString("en-US", { year: "numeric" });

  const formattedDate = `${day}-${month}-${year}`;

  //   obtained_marks

  // max_marks

  // stud_count

  // high_mark.total_marks

  // Maths.marks

  // Math.rank
  return (
    <>
      <div className="firstPageCard">
        <div className="card-body">
          <div className="card-title">
            <div className="text">RBTS Full Test</div>
            <div className="date">{formattedDate}</div>
          </div>

          <div className="card-contain">
            <div className="lft">
              <div className="lft-top">
                <ul>
                  <li>
                    <div className="TestReportCard">
                      <div className="text">
                        <div className="text-top">Marks</div>
                        <div>
                          <div className="text-btm">Out of 300</div>
                        </div>
                      </div>
                      <div className="num marks">
                        {studentData.student_summary.total_marks}
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="TestReportCard">
                      <div className="text">
                        <div className="text-top">Rank</div>
                        <div>
                          <div className="text-btm">600 Students</div>
                        </div>
                      </div>
                      <div className="num rank">
                        {studentData.student_summary.rank}
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="TestReportCard">
                      <div className="text">
                        <div className="text-top">Accuracy</div>
                      </div>
                      <div className="num">
                        {Math.round(studentData.student_summary.Accuracy)}
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="TestReportCard">
                      <div className="text">
                        <div className="text-top">Highest Marks</div>
                      </div>
                      <div className="num">
                        {studentData.student_summary.highest_marks}
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="TestReportCard">
                      <div className="text">
                        <div className="text-top">Average Marks</div>
                      </div>
                      <div className="num">
                        {studentData.student_summary.avg_score}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="lft-btm">
                <div
                  className="percentageBox"
                  style={{
                    backgroundColor: studentData.student_summary.performance,
                    border: `1px solid ${studentData.student_summary.background_color}`,
                  }}
                >
                  <div>
                    <div className="text">Percentile</div>
                    <div className="num">
                      {studentData.student_summary.percentile}
                    </div>
                  </div>
                  <div className="img">
                    {/* <img src={images.user_activity_46} alt="img" /> */}
                    {/* <img src={images.user_activity_46_1} alt="img" fill={studentData.student_summary.background_color} /> */}
                    <svg
                      width="35"
                      height="32"
                      viewBox="0 0 35 32"
                      fill={studentData.student_summary.background_color}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="healthicons:i-certificate-paper-outline">
                        <g id="Group">
                          <path
                            id="Vector"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.6667 4.33333C10.313 4.33333 9.97391 4.47381 9.72386 4.72386C9.47381 4.97391 9.33333 5.31304 9.33333 5.66667V24.3333C9.33333 24.687 9.47381 25.0261 9.72386 25.2761C9.97391 25.5262 10.313 25.6667 10.6667 25.6667H18V27H10.6667C9.95942 27 9.28115 26.719 8.78105 26.219C8.28095 25.7189 8 25.0406 8 24.3333V5.66667C8 4.95942 8.28095 4.28115 8.78105 3.78105C9.28115 3.28095 9.95942 3 10.6667 3H24C24.7072 3 25.3855 3.28095 25.8856 3.78105C26.3857 4.28115 26.6667 4.95942 26.6667 5.66667V24.3333C26.6667 25.0406 26.3857 25.7189 25.8856 26.219C25.3855 26.719 24.7072 27 24 27H22V25.6667H24C24.3536 25.6667 24.6928 25.5262 24.9428 25.2761C25.1929 25.0261 25.3333 24.687 25.3333 24.3333V5.66667C25.3333 5.31304 25.1929 4.97391 24.9428 4.72386C24.6928 4.47381 24.3536 4.33333 24 4.33333H10.6667Z"
                            fill={studentData.student_summary.background_color}
                          />
                          <path
                            id="Vector_2"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.3385 7.66667C13.3385 7.48986 13.4088 7.32029 13.5338 7.19526C13.6588 7.07024 13.8284 7 14.0052 7H20.6719C20.8487 7 21.0183 7.07024 21.1433 7.19526C21.2683 7.32029 21.3385 7.48986 21.3385 7.66667C21.3385 7.84348 21.2683 8.01305 21.1433 8.13807C21.0183 8.2631 20.8487 8.33333 20.6719 8.33333H14.0052C13.8284 8.33333 13.6588 8.2631 13.5338 8.13807C13.4088 8.01305 13.3385 7.84348 13.3385 7.66667ZM10.6719 11.6667C10.6719 11.4899 10.7421 11.3203 10.8671 11.1953C10.9922 11.0702 11.1617 11 11.3385 11H23.3385C23.5154 11 23.6849 11.0702 23.8099 11.1953C23.935 11.3203 24.0052 11.4899 24.0052 11.6667C24.0052 11.8435 23.935 12.013 23.8099 12.1381C23.6849 12.2631 23.5154 12.3333 23.3385 12.3333H11.3385C11.1617 12.3333 10.9922 12.2631 10.8671 12.1381C10.7421 12.013 10.6719 11.8435 10.6719 11.6667ZM10.6719 14.3333C10.6719 14.1565 10.7421 13.987 10.8671 13.8619C10.9922 13.7369 11.1617 13.6667 11.3385 13.6667H23.3385C23.5154 13.6667 23.6849 13.7369 23.8099 13.8619C23.935 13.987 24.0052 14.1565 24.0052 14.3333C24.0052 14.5101 23.935 14.6797 23.8099 14.8047C23.6849 14.9298 23.5154 15 23.3385 15H11.3385C11.1617 15 10.9922 14.9298 10.8671 14.8047C10.7421 14.6797 10.6719 14.5101 10.6719 14.3333ZM10.6719 17C10.6719 16.8232 10.7421 16.6536 10.8671 16.5286C10.9922 16.4036 11.1617 16.3333 11.3385 16.3333H23.3385C23.5154 16.3333 23.6849 16.4036 23.8099 16.5286C23.935 16.6536 24.0052 16.8232 24.0052 17C24.0052 17.1768 23.935 17.3464 23.8099 17.4714C23.6849 17.5964 23.5154 17.6667 23.3385 17.6667H11.3385C11.1617 17.6667 10.9922 17.5964 10.8671 17.4714C10.7421 17.3464 10.6719 17.1768 10.6719 17ZM20.0052 23.6667C20.3588 23.6667 20.698 23.5262 20.948 23.2761C21.1981 23.0261 21.3385 22.687 21.3385 22.3333C21.3385 21.9797 21.1981 21.6406 20.948 21.3905C20.698 21.1405 20.3588 21 20.0052 21C19.6516 21 19.3124 21.1405 19.0624 21.3905C18.8124 21.6406 18.6719 21.9797 18.6719 22.3333C18.6719 22.687 18.8124 23.0261 19.0624 23.2761C19.3124 23.5262 19.6516 23.6667 20.0052 23.6667ZM20.0052 25C20.7125 25 21.3907 24.719 21.8908 24.219C22.3909 23.7189 22.6719 23.0406 22.6719 22.3333C22.6719 21.6261 22.3909 20.9478 21.8908 20.4477C21.3907 19.9476 20.7125 19.6667 20.0052 19.6667C19.298 19.6667 18.6197 19.9476 18.1196 20.4477C17.6195 20.9478 17.3385 21.6261 17.3385 22.3333C17.3385 23.0406 17.6195 23.7189 18.1196 24.219C18.6197 24.719 19.298 25 20.0052 25Z"
                            fill={studentData.student_summary.background_color}
                          />
                          <path
                            id="Vector_3"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M19.3333 23.6641H18V29.6641L20 28.6641L22 29.6641V23.6641H20.6667V27.5067L20 27.1734L19.3333 27.5067V23.6641Z"
                            fill={studentData.student_summary.background_color}
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="d-flex flex-column align-items-end">
                    <div className="text">Percentage</div>
                    <div className="num text-end">
                      {studentData.student_summary.percentage}
                    </div>
                  </div>
                </div>

                <div className="subjs">
                  <ul>
                    {studentData.student_summary?.Physics?.user_score !==
                      null &&
                    studentData.student_summary?.Physics?.user_score !== 0 ? (
                      <li className="li-1">
                        <div className="text">Physics</div>
                        <div className="num">
                          {studentData.student_summary?.Physics?.rank}
                        </div>
                      </li>
                    ) : null}

                    {studentData.student_summary?.Chemistry?.user_score !==
                      null &&
                    studentData.student_summary?.Chemistry?.user_score !== 0 ? (
                      <li className="li-2">
                        <div className="text">Chemistry</div>
                        <div className="num">
                          {studentData.student_summary?.Chemistry?.rank}
                        </div>
                      </li>
                    ) : null}

                    {studentData.student_summary?.Maths?.user_score !== null &&
                    studentData.student_summary?.Maths?.user_score !== 0 ? (
                      <li className="li-3">
                        <div className="text">Maths</div>
                        <div className="num">
                          {studentData.student_summary?.Maths?.rank}
                        </div>
                      </li>
                    ) : null}

                    {studentData.student_summary?.Botany?.user_score !== null &&
                    studentData.student_summary?.Botany?.user_score !== 0 ? (
                      <li className="li-1">
                        <div className="text">Botany</div>
                        <div className="num">
                          {studentData.student_summary?.Botany?.rank}
                        </div>
                      </li>
                    ) : null}

                    {studentData.student_summary?.Zoology?.user_score !==
                      null &&
                    studentData.student_summary?.Zoology?.user_score !== 0 ? (
                      <li>
                        <div className="text">Zoology</div>
                        <div className="num">
                          {studentData.student_summary?.Zoology?.rank}
                        </div>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
            </div>

            <div className="rght">
              {/* <div className="type">obj Type</div> */}
              <div className="viewReport">
                <button
                // onClick={() =>
                //   handleStep2(
                //     studentData.paper_id,
                //     studentData.planner_test_id
                //   )
                // }
                >
                  <span className="text">View report</span>

                  <span>
                    <div className="img">
                      <img src={images.user_activity_47} alt="img" />
                    </div>
                  </span>
                </button>
              </div>
              <div
                className="downloadReport"
                onClick={() => handleRedirect(studentData.paper_id)}
              >
                <button>
                  <span className="text">Download report</span>
                  <span>
                    <div className="img">
                      <img src={images.user_activity_48_1} alt="img" />
                    </div>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Parent);
